// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"20c320e8","422":"2532292b","457":"6b29918b"}[chunkId] + ".chunk.js";
};